import { isDefined } from "./is-defined";

export const createParams = (params?: Record<string, unknown>): string => {
  const filteredParams = Object.entries(params ?? {}).reduce(
    (acc, [key, value]) => {
      if (isDefined(value) && value != "") acc[key] = value;
      return acc;
    },
    {} as Record<string, unknown>
  );
  const paramsString = new URLSearchParams(
    Object.fromEntries(Object.entries(filteredParams).map(([k, v]) => [k, String(v)]))
  ).toString();
  if (!paramsString) return "";
  return "?" + paramsString;
};
